/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AuthInit } from "./modules/Auth";
import { Routes } from "../app/Routes";
import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import { NotificationContainer } from "../_component/react-notifications";
import DataProvider from "../redux/ProfileContext";

export default function App({ store, persistor, basename }) {
  return (
    <Provider store={store}>
      <DataProvider>
        <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
          <React.Suspense fallback={<LayoutSplashScreen />}>
            <BrowserRouter basename={basename}>
              <MaterialThemeProvider>
                <I18nProvider>
                  <AuthInit>
                    <NotificationContainer />
                    <Routes />
                  </AuthInit>
                </I18nProvider>
              </MaterialThemeProvider>
            </BrowserRouter>
          </React.Suspense>
        </PersistGate>
      </DataProvider>
    </Provider>
  );
}
